/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Field_DriverInputs */

const vi_cdo_field_driver = /** @type {(inputs: Cdo_Field_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế`)
};

/**

* @param {Cdo_Field_DriverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_field_driver = /** @type {((inputs?: Cdo_Field_DriverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Field_DriverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_field_driver(inputs)
});